import React, { Suspense } from "react";
import { Route, Routes as Switch } from "react-router-dom";
import DefaultLayout from "../layouts/DefaultLayout";
import AuthLayout from "../layouts/AuthLayout";
import { useUser } from "../contexts/UserContext";

const Routes = () => {
  const { token } = useUser();
  return (
    <Suspense fallback={<div></div>}>
      <Switch>
        {token ? (
          <>
            <Route path="/*" element={<DefaultLayout />} />
          </>
        ) : (
          <>
            <Route path="/*" element={<AuthLayout />} />
          </>
        )}
      </Switch>
    </Suspense>
  );
};

export default Routes;
